// Service Worker Registration with Update Detection
// This module handles SW registration and notifies the app when updates are available

export const registerServiceWorker = (onUpdate) => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('[SW] Service Worker registered with scope:', registration.scope);
          
          // Check for updates periodically (every 30 minutes)
          setInterval(() => {
            registration.update();
          }, 30 * 60 * 1000);
          
          // Listen for new service worker installing
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            console.log('[SW] New service worker installing...');
            
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content is available, notify the app
                console.log('[SW] New content available!');
                if (onUpdate) {
                  onUpdate();
                }
              }
            });
          });
        })
        .catch((error) => {
          console.error('[SW] Service Worker registration failed:', error);
        });
      
      // Listen for messages from the service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'SW_UPDATED') {
          console.log('[SW] Received update notification, version:', event.data.version);
          if (onUpdate) {
            onUpdate();
          }
        }
      });
      
      // Handle controller change (new SW took over)
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          console.log('[SW] New service worker activated, page will refresh');
          // Small delay to show the notification before refresh
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      });
    });
  }
};

// Force update - skip waiting and activate new SW
export const skipWaiting = () => {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
  }
};
